module.exports = __webpack_public_path__ + "static/media/P01.55f3ee40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panel_strobe/P01.png
// module id = 191
// module chunks = 0